import type { ReactNode } from 'react';
import { Badge, StatCard, type BadgeTone } from '@/components/data';
import { formatBRL } from '@/components/foundations/Amount';

export type BillStatus = 'open' | 'forecast' | 'paid';

export const BILL_STATUS: Record<BillStatus, { label: string; tone: BadgeTone }> = {
  open: { label: 'Aberta', tone: 'gold' },
  forecast: { label: 'Prevista', tone: 'neutral' },
  paid: { label: 'Paga', tone: 'ok' },
};

export type BillCardProps = {
  status: BillStatus;
  /** Mês de referência (ex.: "Novembro 2026"). */
  month: ReactNode;
  /** Total, em reais. */
  amount: number;
  /** Fechamento/vencimento ou data de pagamento. */
  meta?: ReactNode;
};

/** Fatura do cartão: aberta (destacada), prevista ou paga. */
export function BillCard({ status, month, amount, meta }: BillCardProps) {
  const s = BILL_STATUS[status];
  return <StatCard icon="card" label={month} value={formatBRL(amount)} info={false} hint={meta} badge={<Badge tone={s.tone}>{s.label}</Badge>} highlight={status === 'open'} />;
}
